import Video from "./upper.mp4"

export default function AppIntroVideo() {
  return (
    <video
      width={"100%"}
      autoPlay={true}
      loop
      muted
      playsInline
      preload={"true"}
    >
      <source src={Video} />
    </video>
  )
}
